import React from 'react';

import RecipesList from './resipesList';

export default function VisitRecipes({ drugs }) {
  if(!drugs || drugs.length === 0) return null;
  return (
    <div className="personal-recipes">
      <div className="personal-recipes-title">
        Рецепти препаратів щодо візиту <span>({drugs.length})</span>
      </div>

      <RecipesList drugs={drugs} />
    </div>
  );
}
